const EmployeeBookingsState = {
  data: []
}

export default EmployeeBookingsState
